 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Booking~Home~Loading~NoShow~Profile~Recover~forgot~login":"Booking~Home~Loading~NoShow~Profile~Recover~forgot~login","Booking~Home~NoShow~Profile~Recover~forgot~login":"Booking~Home~NoShow~Profile~Recover~forgot~login","Booking~Home~NoShow~Profile":"Booking~Home~NoShow~Profile","Booking~Home~forgot~login":"Booking~Home~forgot~login","Booking":"Booking","Home":"Home","ListServices~NoShow~Profile~Recover~forgot~login":"ListServices~NoShow~Profile~Recover~forgot~login","NoShow":"NoShow","Profile":"Profile","forgot":"forgot","login":"login","Recover":"Recover","Chat":"Chat","LisChat":"LisChat","SelectUnit":"SelectUnit","update":"update","ListServices~Loading":"ListServices~Loading","Loading":"Loading","Gmap":"Gmap","Offline":"Offline","binnacle":"binnacle","qrreader":"qrreader","services":"services","Camera":"Camera","Empty":"Empty","ListServices":"ListServices"}[chunkId]||chunkId) + "." + {"Booking~Home~Loading~NoShow~Profile~Recover~forgot~login":"9b2d994d","Booking~Home~NoShow~Profile~Recover~forgot~login":"99241af1","Booking~Home~NoShow~Profile":"a6aec5ea","Booking~Home~forgot~login":"2d502aa2","Booking":"9067daf8","Home":"3defb0a0","ListServices~NoShow~Profile~Recover~forgot~login":"85ced4d4","NoShow":"fa04fecf","Profile":"0b819d0e","forgot":"cb2b1e87","login":"1fd42a2c","Recover":"4ce88a5c","Chat":"70958199","LisChat":"4b5c9dae","SelectUnit":"e4a866fd","chunk-2d208e4e":"c8ba22cf","chunk-2d21e70e":"6e77f231","chunk-2d230c96":"a40464aa","update":"dd182b49","ListServices~Loading":"1191b1d1","Loading":"7aee72de","Gmap":"f1c9dfa6","Offline":"5f93eb25","binnacle":"154148d8","qrreader":"1fe22e09","services":"e5fdb83c","Camera":"a0afae4a","Empty":"55b3e129","ListServices":"3ca1a75a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Booking~Home~Loading~NoShow~Profile~Recover~forgot~login":1,"Booking~Home~NoShow~Profile~Recover~forgot~login":1,"Booking~Home~NoShow~Profile":1,"Booking~Home~forgot~login":1,"Booking":1,"Home":1,"ListServices~NoShow~Profile~Recover~forgot~login":1,"NoShow":1,"Profile":1,"forgot":1,"login":1,"Recover":1,"Chat":1,"LisChat":1,"SelectUnit":1,"update":1,"ListServices~Loading":1,"Loading":1,"Gmap":1,"Offline":1,"qrreader":1,"Camera":1,"Empty":1,"ListServices":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Booking~Home~Loading~NoShow~Profile~Recover~forgot~login":"Booking~Home~Loading~NoShow~Profile~Recover~forgot~login","Booking~Home~NoShow~Profile~Recover~forgot~login":"Booking~Home~NoShow~Profile~Recover~forgot~login","Booking~Home~NoShow~Profile":"Booking~Home~NoShow~Profile","Booking~Home~forgot~login":"Booking~Home~forgot~login","Booking":"Booking","Home":"Home","ListServices~NoShow~Profile~Recover~forgot~login":"ListServices~NoShow~Profile~Recover~forgot~login","NoShow":"NoShow","Profile":"Profile","forgot":"forgot","login":"login","Recover":"Recover","Chat":"Chat","LisChat":"LisChat","SelectUnit":"SelectUnit","update":"update","ListServices~Loading":"ListServices~Loading","Loading":"Loading","Gmap":"Gmap","Offline":"Offline","binnacle":"binnacle","qrreader":"qrreader","services":"services","Camera":"Camera","Empty":"Empty","ListServices":"ListServices"}[chunkId]||chunkId) + "." + {"Booking~Home~Loading~NoShow~Profile~Recover~forgot~login":"37a8d14c","Booking~Home~NoShow~Profile~Recover~forgot~login":"9a8ec6c2","Booking~Home~NoShow~Profile":"51e80be2","Booking~Home~forgot~login":"d6c9f139","Booking":"8bbf8483","Home":"7fa1dc75","ListServices~NoShow~Profile~Recover~forgot~login":"38fb335c","NoShow":"28de388c","Profile":"52b4d161","forgot":"958a45c2","login":"cd5b62b0","Recover":"22a483ff","Chat":"0cdf489d","LisChat":"a6c36693","SelectUnit":"8be0ba7e","chunk-2d208e4e":"31d6cfe0","chunk-2d21e70e":"31d6cfe0","chunk-2d230c96":"31d6cfe0","update":"e271d5da","ListServices~Loading":"f0222215","Loading":"19f0b9b6","Gmap":"88c476c1","Offline":"0e745f57","binnacle":"31d6cfe0","qrreader":"b56232c5","services":"31d6cfe0","Camera":"3b57bbd7","Empty":"fc84a781","ListServices":"984b901b"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
